import moment from 'moment'
import { MatchedEntity as MatchedEntityPolicyholder } from '../../@types/PolicyHolderDetails'
import { ResumePetisSimulationProposalClientResponse } from '../../@types/ResumePetisSimulationProposal'
import { useReportStore } from '../../Stores/reportStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'

type EntityType = MatchedEntityPolicyholder | null

export const useProspectHydration = () => {
  const { setInitialDate, setEndDate, setOwnerFiscalNumber } =
    useSimulatorStore()
  const {
    setReport,
    setIsProspect,
    setReportGenerated,
    setIsReportGeneratedEnabled,
  } = useReportStore()

  const handleProspectHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const isSimulation = data.processData?.simulationData
    const isProposal = data.processData?.proposalData
    const isPolicy = data.processData?.policyData
    const proposalOrPolicyData = isProposal || isPolicy
    const initialDate =
      data.entities?.prospectEntity?.initialDate ||
      moment(proposalOrPolicyData?.startDate).format('DD-MM-YYYY') ||
      moment().format('DD-MM-YYYY')

    setIsProspect(true)
    setReportGenerated(true)
    setIsReportGeneratedEnabled(false)
    setOwnerFiscalNumber(
      data.entities?.prospectEntity?.fiscalNumber?.toString() || '',
    )
    setReport({
      vatNumber: data.entities?.prospectEntity?.fiscalNumber?.toString() || '',
      name: data.entities?.prospectEntity?.name || '',
      phone:
        data.entities?.prospectEntity?.contacts?.[0]?.phoneContactNumber?.toString() ||
        '',
      email: data.entities?.prospectEntity?.contacts?.[0]?.email || '',
    })

    setInitialDate(initialDate)
    setEndDate(isSimulation?.endDate || isProposal?.endDate || '')
  }

  return {
    handleProspectHydration,
  }
}
